export enum SizeType {
  FIFTEEN = 0,
  THIRTY = 2,
  FOURTY = 3,
  FIFTY = 4,
  SIXTY = 5,
  EIGHTY = 6,
}
